import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

const Unauthorized = () => (
  <Box textAlign="center" mt={8}>
    <Typography variant="h3" gutterBottom>Access Denied</Typography>
    <Typography variant="subtitle1" gutterBottom>
      You must be logged in to view this page.
    </Typography>
    <Button variant="contained" component={Link} to="/AdminLogin">
      Go to Admin Login
    </Button>
  </Box>
);

export default Unauthorized;